import React from "react";
import HomeBanner from "../Components/HomeBanner/homebanner";
import TabsSection from "../Components/TabsSection/tabsSection"
import SolutionGrowth from '../Components/SolutionGrowth/solutiongrowth';
import HowItWorks from "../Components/HowItWorks/howitworks";
import HomeCTA from "../Components/HomeCta/homeCTA";
import IntegrationSection from "../Components/IntegrationSection/integration";
import AdvanceEstimator from "../Components/AdvanceEstimator/AdvanceEstimator"
import FAQCTA from "../Components/FAQCTA/faqwithcta"
import StoryInvex from "../Components/StoryInvex/storyinvex";
import ContactUs from '../Components/ContactUs/contactus';
import GoodNews from '../Components/GoodNews/index';
import ClaimPayment from '../Components/ClaimPayment/index';
import CompanyAwards from '../Components/CompanyAwards/index';
import Achievement from '../Components/Achivement/index';
import ImageText from '../Components/ImageWIthText/index';
import ConventionalFinance from '../Components/ConventionalFinance/index';
import MultiStep from '../Components/MultiStep/index';
import Slider from '../Components/SliderSection/index';
import FAQ from '../Components/FAQ/index';
import Advantages from '../Components/Advantages/index';


const Home = () => {
        return (
                <>
                        <HomeBanner />
                        {/* <TabsSection /> */}
                        <HowItWorks />
                        <SolutionGrowth />
                        <StoryInvex />
                        <ContactUs />
                        <HomeCTA />
                        {/* <Steps />
                        <GrowBussines /> */}
                        {/* <TrustedBy /> */}
                        {/* <CashFlow /> */}
                        {/* <GoodNews /> */}
                        {/* <ClaimPayment /> */}
                        {/* <Achievement /> */}
                        {/* <CompanyAwards /> */}
                        {/* <Slider /> */}
                        {/* <ConventionalFinance /> */}
                        {/* <MultiStep /> */}
                        {/* <Advantages /> */}
                        {/* <ImageText /> */}
                        {/* <FAQ /> */}
                </>
        );
}

export default Home;